/**
 * Conditional company-contact rule (MR !388 final decision 1).
 *
 * The contact fields (company_email / company_phone) are NOT always required:
 *
 *   - NIPC KNOWN  (lookup.found === true): the company already exists, so its
 *     owner is reached through the employment bond / informational employment.
 *     The driver is never asked for a corporate contact and must never supply
 *     their personal email/phone. Contact is therefore NOT required.
 *   - NIPC UNKNOWN (lookup.found === false): no company exists, a lead is
 *     recorded, and the (existing) owner must be notified — so a contact
 *     (email OR phone) IS required.
 *   - lookup not yet performed (null): treat as "not yet known" → require a
 *     contact until the lookup proves the company exists.
 *
 * This is a pure function so it can be unit-tested without rendering the screen
 * and reused by the register/driver validation.
 */
export interface CompanyLookupResult {
  found: boolean;
  name?: string;
  tax_identifier?: string;
}

export function isCompanyContactRequired(
  lookup: CompanyLookupResult | null,
  email: string,
  phone: string,
): boolean {
  const hasContact = (email || '').trim().length > 0 || (phone || '').trim().length > 0;
  // Known company never requires a contact.
  if (lookup?.found === true) return false;
  // Unknown or not-yet-looked-up: a contact is mandatory.
  return !hasContact;
}
